import {COLORS} from 'core/styles';
import styled from 'styled-components';

export const ActionButtonStyled = styled.div`
    ${(props) => (props.$css ? props.$css : '')}
    .container {
        cursor: pointer;
        display: inline-block;
        width: 25px;
        height: 25px;
        transition: opacity 200ms ease;
    }
`;
